module.exports = __webpack_public_path__ + "img/web-event.918c6adc.png";